var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"youtube-videos",class:_vm.videoClasses},_vm._l((_vm.items),function(video,index){return _c('YouTubeVideo',{key:`youtube-video-${index}`,class:{'content-bg': _vm.parse(video).boxed},attrs:{"url":_vm.parse(video).video_url}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }